import { Box } from "@mui/material";
import {
  ParticipantData,
  Appointment,
} from "../interface/bookingOverviewInterface";
import RenderAppointment from "./renderAppointment";

const renderAppointments = ({
  participant,
}: {
  participant: ParticipantData;
}): React.JSX.Element[] =>
  participant.appointments.data.map(
    (appointment: Appointment, index: number) => (
      <Box key={index}>
        <RenderAppointment
          appointment={appointment}
          index={index}
          participant={participant}
        />
      </Box>
    )
  );

export default renderAppointments;
